const vampireMonicaPlayerSpritesheet = {
  "name": "vampireMonicaPlayerSpritesheet",
  "tileHeight": 128,
  "tileWidth": 128,
  "spacing": 0,
  "tileCount": 2,
  "columns": 2,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/vampireMonicaPlayerSpritesheet.png",
  "sprites": {
    "vampireMonicaPlayerHead": [0],
    "vampireMonicaPlayerBody": [1]
  }
}
export default vampireMonicaPlayerSpritesheet;
